import { ModalErrorConfig } from '@core/interfaces/modal-error-config.interface';
import { PROJECT_TYPE } from '@core/types/projects.type';

export const RECAPTCHA_CONFIG = new Map<PROJECT_TYPE, ModalErrorConfig>([
  [
    'ACC',
    {
      imageUrl: {
        url: 'assets/img/errors/error__page-recaptcha.svg',
        altUrl: 'Information for recaptcha icon/illustration',
      },
      errorTitle: 'Hubo un error',
      errorDescription:
        'Tuvimos problemas al abrir tu cuenta. Por tu seguridad, volveremos a comenzar.',
      buttonLabel: 'Volver al inicio',
    },
  ],
  [
    'PLD',
    {
      imageUrl: {
        url: 'assets/img/errors/error__page-recaptcha.svg',
        altUrl: 'Information for recaptcha icon/illustration',
      },
      errorTitle: 'Hubo un error',
      errorDescription:
        'Tuvimos problemas para continuar con la solicitud de tu préstamo. Por tu seguridad, volveremos a comenzar',
      buttonLabel: 'Volver al inicio',
    },
  ],
  [
    'FTD',
    {
      imageUrl: {
        url: 'assets/img/errors/error__page-recaptcha.svg',
        altUrl: 'Information for recaptcha icon/illustration',
      },
      errorTitle: 'Hubo un error',
      errorDescription:
        'Tuvimos problemas al abrir tu depósito a plazo fijo. Por tu seguridad, volveremos a comenzar.',
      buttonLabel: 'Volver al inicio',
    },
  ],
]);
